import React, { useRef, useState,useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { SubmitHandler, FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import {
  Container,
  Box,
  Divider,
  CardContent,
  Button,
  Typography,
} from '@material-ui/core';
import Input from '../../components/Input/index';
import AMCLogo from '../../assets/logoamc.png';
import LogoExtended from '../../assets/extendedLogo.svg';
import api from '../../services/api';
import { optionStyles } from './styles';
import Colors from '../../components/Colors';

interface FormData {
  password: string;
  newPassword:string;
}

const UpdatePassword: React.FC = () => {
  const authHeader = useMemo(() => {
    return { Authorization: `Token ${localStorage.getItem('auth')}` };
  }, []);

  const classes = optionStyles();
  const [mensage,setMensage] = useState('');
  const [colorMensage,setColorMensage]=useState('');
  const formRef = useRef<FormHandles>(null);

  const handleSubmit: SubmitHandler<FormData> = async (data) => {
    await api
    .put("/api/change-pass/", data, {
      headers: authHeader,
    }).then((response)=>{
        if(response.status === 200 || response.status === 201){
          setColorMensage('#009048');
          setMensage('Senha alterada com sucesso!');
        }else{
          setMensage('Senha atual incorreta, por favor verifique e tente novamente.');
          setColorMensage('#90002B');
        }
      }
      ).catch( () =>{
        setMensage('Ocorreu um erro inesperado, recarregue a página e tente novamente, ou caso persista, tente novamente mais tarde!');
        setColorMensage('#90002B');
      });
  };
  return (
    <Container maxWidth="xl" className={classes.rootContainer}>
      <Box className={classes.rootCard}>
        <CardContent style={{ width: '80%' }}>
          <img src={LogoExtended} alt="Logo VIDA" width="200" className={classes.logo} />
          <Divider className={classes.divider} orientation="horizontal" />
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
            <Typography variant="h6" style={{ color: '#404040', marginBottom: '5%' }}>Alterar senha
            </Typography>
          </div>
          <Form className={classes.rootForm} ref={formRef} onSubmit={handleSubmit}>
            <Typography variant="subtitle2" style={{ color: colorMensage, marginBottom: '5%' }}>{mensage}</Typography>
            <Input
              name="password"
              label="Senha atual:"
              type="password"
              required
              placeholder="Sua senha atual"
            />
            <Input
              name="newPassword"
              label="Nova senha:"
              type="password"
              required
              placeholder="Sua nova senha"
            />
            <Button variant="outlined" className={classes.rootButton} type="submit">
              Alterar
            </Button>
            <Link to="/minhaconta" style={{ color: Colors.main,textDecoration:'none', marginTop:'2%' }}>
              Voltar
            </Link>
          </Form>
        </CardContent>
        <img src={AMCLogo} alt="Logo VIDA" width="200" className={classes.logoamc} />

      </Box>
    </Container>
  );
};

export default UpdatePassword;
